import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of, throwError } from 'rxjs';
import { Form } from '../../domain/form.interface';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  constructor(private api: ApiService) {}

  getForms(): Observable<any[]> {
    console.log('Get Forms')    
    return this.api.get(`/forms`);
  }
  getForm(form: Form): Observable<{ content: Form }> {
    return this.api.get(`/forms/${form.sk}`);
  }

  addForm(form: Form): Observable<{ content: Form }> {  
    //const error = new HttpErrorResponse({ status: 500, error: "Testing error" });
    //return throwError(() => error)  
    return this.api.post(`/forms`, form);
  }

  editForm(form: Form): Observable<{ content: Form }> {
    return this.api.put(`/forms/${form.sk}`, form);
  }

  deleteForm(form: Form): Observable<{ content: { form: Form } }> {
    console.log('Delete Form')
    return this.api.delete(`/forms/${form.sk}`, form);
  }

  cloneForm(form: Form): Observable<{ content: Form }> {  
    return this.api.post(`/forms/${form.sk}/clone`, form);
  }

}
